import styled from '@emotion/styled';
import { casinoColors } from 'src/assets/colors';
import { FolderPlusIcon } from 'src/assets/icons/FolderPlusIcon';
import { TrashIcon } from 'src/assets/icons/TrashIcon';
import { ButtonWithIcon } from 'src/components/ButtonWithIcon/ButtonWithIcon';
import { UploadImageDimentionsType } from './ImageUpload';

export const FolderPlusIconWrapper = styled(FolderPlusIcon, { label: 'FolderPlusIconWrapper' })`
    position: absolute;
    margin: 0 0 0 8px;
`;

export const TrashIconWrapper = styled(TrashIcon, { label: 'TrashIconWrapper' })`
    fill: ${casinoColors.white};
    margin: 0 8px 0 0;
`;

export const ImageUploadWrapper = styled('div', { label: 'ImageUploadWrapper' })`
    display: flex;
`;

export const ButtonsWrapper = styled('div', { label: 'ButtonsWrapper' })`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const InputWrapper = styled('div', { label: 'InputWrapper' })`
    display: inline-flex;
    position: relative;
    align-items: center;
    width: 173px;
`;

export const FileInputLabel = styled('label', { label: 'FileInputLabel' })`
    color: ${casinoColors.white};
    max-height: 32px;
    display: inline-block;
    white-space: nowrap;
    border-radius: 4px;
    transition: .3s ease background-color;
    font-size: 14px;
    font-weight: bold;
    background: ${casinoColors.coolBlue};
    padding: 5px 16px 13px 32px;
    cursor: pointer;
`;

interface FileInputPropsType {
    accept: string;
    onChange: (event: React.SyntheticEvent<HTMLInputElement>) => void;
}

export const FileInput = styled('input', { label: 'FileInput' })<FileInputPropsType>`
    display: none;
`;

export const RemoveButtonWrapper = styled(ButtonWithIcon, { label: 'RemoveButtonWrapper' })`
    background: ${casinoColors.buttonColorRemoveImg};
    cursor: pointer;
    padding: 8px;
    margin-top: 4px;
`;

export const OptimalizeButton = styled('button', { label: 'OptimalizeButton' })`
    background: ${casinoColors.buttonColorOptimiseImg};
    border: none;
    border-radius: 4px;
    color: ${casinoColors.white};
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    margin-top: 4px;
    max-height: 32px;
    padding: 8px;
    transition: .3s ease background-color;
`;

const buildImageWrapperStyles = (dimensions: UploadImageDimentionsType): string => {
    if (dimensions === 'vertical') {
        return `
            width: 138px;
            height: 200px;
        `;
    } else if (dimensions === 'square') {
        return `
            width: 200px;
            height: 200px;
        `;
    }
    return `
        width: 200px;
        height: 138px;
    `;
};

interface ImageWrapperPropsType {
    dimensions: UploadImageDimentionsType;
}

export const ImageWrapper = styled('div', { label: 'ImageWrapper' })<ImageWrapperPropsType>`
    ${({ dimensions }): string => buildImageWrapperStyles(dimensions)};
    margin: 0 17px 0 0;
`;

export const Image = styled('img', { label: 'Image' })`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

interface ImagePlaceholderPropsType {
    dimensions: UploadImageDimentionsType;
}

export const ImagePlaceholder = styled('div', { label: 'ImagePlaceholder' })<ImagePlaceholderPropsType>`
    ${({ dimensions }): string => buildImageWrapperStyles(dimensions)};
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${casinoColors.white};
    font-size: 12px;
    border-radius: 4px;
    border: solid 1px ${casinoColors.paleGrey};
    background-color: ${casinoColors.blueGray};
`;

interface SizeInfoPropsType {
    isTooBig: boolean;
}

export const SizeInfo = styled('div', { label: 'SizeInfo' })<SizeInfoPropsType>`
    color: ${({ isTooBig }): string => isTooBig === true ? casinoColors.txtColorWarningInfo : 'inherit'};
    font-size: 12px;
`;
